import React, { Fragment } from "react";
import Navbar from "../components/header/header.component";
import Footer from "../components/Footer/Footer.component.js";
import TablemenuComponent from "../components/Tablemenu/Tablemenu.component.js";
import menutableimage1 from "../images/menutable1.png";
import menutableimage2 from "../images/menutable2.png";
import menutableimage3 from "../images/menutable3.png";
import menutableimage4 from "../images/menutable4.png";
import { Helmet } from "react-helmet";

const Tablemenu = () => {
  return (
    <Fragment className="w-100">

      <Helmet>
        <title>Tablemenu | Taco Twist</title>
        <meta name="description" content="Discover the nearest taco place with Taco Twist! Indulge in flavorful delights at tacotwist.com. Explore our menu for a tasty taco experience right around the corner!
" />


      </Helmet>

      <Navbar />
<div className="text-center">
       <h1 className="text-3xl font-bold mb-6 text-center">Tablemenu</h1>
      <div>
      <img src={menutableimage1} alt="Menu Image"/>
      </div>
      <br></br>
      <br></br>
     
      <div>
      <img src={menutableimage2} alt="Menu Image"/>
      </div>
      <br></br>
      <br></br>
      
      <div>
      <img src={menutableimage3} alt="Menu Image"/>
      </div>
      <br></br>
      <br></br>
      <div>
      <img src={menutableimage4} alt="Menu Image"/>
      </div>
      <br></br>
      <br></br>
    </div>
      {/* <TablemenuComponent /> */}
      <Footer />
    </Fragment>
  );
};

export default Tablemenu;
